import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';
import { LOGIN_URL } from '../shared/constants/urls.const';
import { BaseResponse } from '../shared/models/base-response.model';
import { NotificationService } from '../shared/services/notification.service';
import { TokenStorageService } from '../shared/services/token.service';
import { AccountService, Profile } from '../proxy/account';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
})
export class AppTopBarComponent implements OnInit {
    items: MenuItem[] = [];
    userMenuItems: MenuItem[];
    private ngUnsubscribe = new Subject<void>();

    public profile: Profile = null;

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        private authService: AuthService,
        private notificationService: NotificationService,
        private router: Router,
        private accountService: AccountService,
        private tokenService: TokenStorageService,
    ) {}

    ngOnInit(): void {
        this.userMenuItems = [
            {
                label: 'T.tin cá nhân',
                icon: 'pi pi-id-card',
                routerLink: ['/account/profile'],
            },
            {
                label: 'Đổi mật khẩu',
                icon: 'pi pi-key',
                routerLink: ['/account/change-password'],
            },
            {
                label: 'Đăng xuất',
                icon: 'pi pi-sign-out',
                command: (event) => {
                    this.authService.logoutServer().subscribe({
                        next: (rs: BaseResponse<any>) => {
                            if (rs.success) {
                                this.authService.logout();
                                this.router.navigate([LOGIN_URL]);
                            } else {
                                this.notificationService.showError(rs.message);
                            }
                        },
                        error: (ex) => {
                            const errorCode: string = ex.error.errorCode;
                            this.notificationService.showError(errorCode);
                        },
                    });
                },
            },
        ];

        const permissions = JSON.parse(this.tokenService.getPermission());
        if (
            permissions &&
            permissions.filter((x) => x === 'view booking').length > 0
        ) {
            this.items.push(
                {
                    label: 'Trang chủ',
                    icon: 'pi pi-fw pi-home',
                    routerLink: ['/booking'],
                },
                {
                    label: 'Chờ xử lý',
                    icon: 'pi pi-fw pi-clock',
                    routerLink: ['/pending-booking'],
                },
            );
        }
        if (
            permissions &&
            permissions.filter((x) => x === 'view driver').length > 0
        ) {
            this.items.push({
                label: 'Tài xế',
                icon: 'pi pi-fw pi-car',
                routerLink: ['/driver'],
            });
        }
        if (
            permissions &&
            permissions.filter((x) => x === 'view customer').length > 0
        ) {
            this.items.push({
                label: 'Hành khách',
                icon: 'pi pi-users',
                routerLink: ['/customer'],
            });
        }
        if (
            permissions &&
            permissions.filter((x) => x === 'view call').length > 0
        ) {
            this.items.push({
                label: 'Cuộc gọi',
                icon: 'pi pi-fw pi-phone',
                routerLink: ['/call-list'],
            });
        }
        if (
            permissions &&
            permissions.filter((x) => x === 'view staff').length > 0
        ) {
            this.items.push({
                label: 'Nhân viên',
                icon: 'pi pi-user-plus',
                routerLink: ['/employee'],
            });
        }
        if (
            permissions &&
            permissions.filter((x) => x === 'view transaction').length > 0
        ) {
            this.items.push({
                label: 'Giao dịch',
                icon: 'pi pi-fw pi-dollar',
                routerLink: ['/transaction'],
            });
        }
        if (
            permissions &&
            permissions.filter((x) => x === 'view bill').length > 0
        ) {
            this.items.push({
                label: 'Hóa đơn',
                icon: 'pi pi-fw pi-book',
                routerLink: ['/e-invoice'],
            });
        }
        this.items.push({
            label: 'Hành trình',
            icon: 'pi pi-send',
            routerLink: ['/trip'],
        });
        this.items.push({
            label: 'Cấu hình',
            icon: 'pi pi-cog',
            routerLink: ['/sys-config'],
        });

        this.getProfile();
    }

    private getProfile() {
        this.accountService
            .getProfile()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response: BaseResponse<Profile>) => {
                    if (response.success == true) {
                        this.profile = response.data;
                    }
                },
                error: () => {},
            });
    }
}
